import { AxiosError } from 'axios';

export const protectAxiosError = <T>(error: any): error is AxiosError<T> =>
  'message' in error && 'isAxiosError' in error ? true : false;
